import { combineReducers } from 'redux'
import { reducer as authReducer } from './slices/auth'
import { reducer as notificationReducer } from './slices/notification'
import { reducer as uiReducer } from './slices/ui'
import { connectRouter } from 'connected-react-router'
import { reducer as profileReducer } from './slices/profile'
import { reducer as contentReducer } from './slices/content'

export const createRootReducer = (history: any) => combineReducers({
  router: connectRouter(history),
  auth: authReducer,
  notification: notificationReducer,
  ui: uiReducer,
  profile: profileReducer,
  content: contentReducer,

})